// utils/labelRegistry.js
// qual t-key pertence a qual chave canônica?
export const tKeyToCanonical = {
  /* ─── branch ─────────────────────────────────────────── */
  "new_initiatives.fields.branch": "branch",
  "program_setup.table_head.branch": "branch",
  "program_setup.table_head.branch_name": "branch",
  "initiatives.columns.branch": "branch",
  "filters.all_branches": "filter_all_branch",
  "program_setup.filters.all_branches": "filter_all_branch",

  /* ─── sponsor ──────────────────────────────────────── */
  "filters.all_sponsors": "filter_all_sponsor",

  /* ─── workfront ──────────────────────────────────────── */
  "new_initiatives.fields.workfront": "workfront",
  "program_setup.table_head.workfront": "workfront",
  "program_setup.table_head.workfront_name": "workfront",
  "filters.all_workfronts": "filter_all_workfront",
  "program_setup.filters.all_workfronts": "filter_all_workfront",

  /* ─── tags ───────────────────────────────────────────── */
  "new_initiatives.fields.tags": "tags",
  "filters.all_tags": "filter_all_tags",

  /* ─── valores KPI na lista de iniciativas ───────────── */
  "initiatives.columns.kpi_actual": "kpi_actual",
  "initiatives.columns.kpi_planned": "kpi_planned",
  "initiatives.columns.kpi_ratio": "kpi_ratio",
  "initiatives.columns.kpi_annual_value_target": "annual_value",
  "new_initiatives.fields.annual_value": "annual_value",
  "initiatives.results_target": "annual_value",

  /* ─── What's Happening – tabela/rodapé/drawer ────────── */
  "whatshappening.table.table_kpi": "table_kpi",
  "whatshappening.table.total_kpi": "total_kpi",
  "whatshappening.table.kpi_drawer": "kpi_drawer",

  /* ─── initiative (contexto específico Porto Seguro) ───── */
  "initiatives.columns.initiative": "initiative",
  "initiatives.columns.workfront": "workfront",
  "new_initiatives.title": "new_initiative_title",
  "new_initiatives.title_edit": "edit_initiative_title",
  "new_initiatives.fields.initiative_name": "initiative_name",
  "new_initiatives.fields.initiative_leader": "initiative_leader",
  "new_initiatives.fields.initiative_leader_2": "initiative_leader_2",
  "new_initiatives.fields.initiative_pmo": "initiative_pmo",
  "initiatives.initiative_list": "initiative_list",
  "initiatives.total_initiatives": "total_initiatives",
  "initiatives.add_new": "add_new_initiative",
  "initiatives.details": "initiative_details",
  "filters.initiatives": "filter_initiatives",
  "sidebar_toffice.execution_menu.initiatives_management":
    "sidebar_initiatives_management",
  "riskmanagement.tableColumns.linkedInitiatives": "linked_initiatives",
  "riskmanagement.fields.linkedInitiatives": "linked_initiatives_field",
  "riskmanagement.fields.selectInitiatives": "select_initiatives",
  "program_meeting.initiatives.list": "program_initiatives_list",
  "program_meeting.filters.initiatives": "program_filter_initiatives",
  "program_meeting.one_page.select_initiative": "program_select_initiative",
  "program_meeting.comments.no_initiative_selected": "no_initiative_selected",
};

export const canonicalToTKey = Object.entries(tKeyToCanonical).reduce(
  (acc, [tKey, canonical]) => {
    if (!acc[canonical]) acc[canonical] = tKey;
    return acc;
  },
  {},
);

export const columnToCanonical = {
  status: null,
  branch: "branch",
  workfront: "workfront",
  initiative: "initiative",
  stage: null,
  leader: null,
  kpi_actual: "kpi_actual",
  kpi_planned: "kpi_planned",
  kpi_ratio: "kpi_ratio",
  kpi_annual_value_target: "annual_value",
};
